'use client';

import { c as _c } from "react/compiler-runtime";
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { cn } from '@module/lib/utils';
import { useBjInfoQuery } from '@module/queries/member/memberQueryHooks';
import PageTab from '@pc/components/molecules/tab/PageTab';
import PageTabsContainer from '@pc/components/molecules/tab/PageTabsContainer';
import { useRouter } from 'next/navigation';
interface ChannelTabsContainerProps {
  channelId: string;
}
function ChannelTabsContainer(t0) {
  const $ = _c(26);
  const {
    channelId
  } = t0;
  const router = useRouter();
  const {
    userInfo,
    wasLive
  } = useGetLoginInfoQuery();
  const isMyChannel = userInfo && channelId === userInfo.id;
  let t1;
  if ($[0] !== channelId) {
    t1 = {
      userId: channelId
    };
    $[0] = channelId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: bjInfoData
  } = useBjInfoQuery(t1);
  let t2;
  if ($[2] !== channelId || $[3] !== router) {
    t2 = () => router.push(`/channel/${channelId}/home/member`);
    $[2] = channelId;
    $[3] = router;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let T0;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[5] !== bjInfoData?.bjInfo || $[6] !== channelId || $[7] !== isMyChannel || $[8] !== router || $[9] !== t2 || $[10] !== userInfo?.authYN || $[11] !== userInfo?.isBJ || $[12] !== wasLive) {
    const channelTabs = [{
      label: "\uD648",
      includedURLPath: "/home",
      onClick: t2,
      condition: isMyChannel,
      className: "ml-0"
    }, {
      label: "\uAE00\uB85C\uBC8C\uC11C\uBE44\uC2A4",
      includedURLPath: "/globalService",
      onClick: () => router.push(`/channel/${channelId}/globalService`),
      condition: isMyChannel && bjInfoData?.bjInfo.globalYN === "Y"
    }, {
      label: "BJ\uACF5\uC9C0\uC0AC\uD56D",
      includedURLPath: "/bjNotice",
      onClick: () => router.push(`/channel/${channelId}/bjNotice`),
      condition: isMyChannel && userInfo?.isBJ === "Y"
    }, {
      label: "\uD658\uC804",
      includedURLPath: "/exchange",
      onClick: () => router.push(`/channel/${channelId}/exchange/apply`),
      condition: isMyChannel && userInfo?.authYN === "Y"
    }, {
      label: "BJ\uC54C\uB9BC",
      includedURLPath: "/notice",
      onClick: () => router.push(`/channel/${channelId}/notice`),
      condition: true,
      className: !isMyChannel ? "ml-0" : ""
    }, {
      label: "\uD32C\uB4F1\uAE09",
      includedURLPath: "/grade",
      onClick: () => router.push(`/channel/${channelId}/grade`),
      condition: true
    }, {
      label: "\uD32C\uB7AD\uD0B9",
      includedURLPath: "/ranking",
      onClick: () => router.push(`/channel/${channelId}/ranking/all`),
      condition: true
    }, {
      label: "\uC2DC\uADF8\uB2C8\uCC98",
      includedURLPath: "/signature",
      onClick: () => router.push(`/channel/${channelId}/signature`),
      condition: !isMyChannel
    }, {
      label: "\uBE14\uB799\uB9AC\uC2A4\uD2B8",
      includedURLPath: "/block",
      onClick: () => router.push(`/channel/${channelId}/block/one`),
      condition: isMyChannel
    }, {
      label: "\uD478\uC2DC\uC124\uC815",
      includedURLPath: "/push",
      onClick: () => router.push(`/channel/${channelId}/push/fan`),
      condition: isMyChannel
    }, {
      label: "\uBC29\uC1A1\uC124\uC815",
      includedURLPath: "/config/",
      onClick: () => router.push(`/channel/${channelId}/config/signature`),
      condition: isMyChannel
    }, {
      label: "PICK\uD68C\uC6D0",
      includedURLPath: "/pickMember",
      onClick: () => router.push(`/channel/${channelId}/pickMember`),
      condition: isMyChannel && wasLive
    }, {
      label: "\uBC29\uC1A1\uB0B4\uC5ED",
      includedURLPath: "/castList",
      onClick: () => router.push(`/channel/${channelId}/castList`),
      condition: isMyChannel
    }, {
      label: "\uBBF8\uC158",
      includedURLPath: "/mission",
      onClick: () => router.push(`/channel/${channelId}/mission`),
      condition: isMyChannel
    }];
    t6 = "channel-tabs";
    T0 = PageTabsContainer;
    t3 = "min-w-[1360px]";
    t4 = "text-left w-[1360px] px-10 mx-auto flex flex-nowrap";
    t5 = channelTabs.filter(_temp).map(tab_0 => <PageTab key={tab_0.label} includedURLPath={tab_0.includedURLPath} onClick={tab_0.onClick} className={cn(tab_0.className, {
      "mx-[14px]": bjInfoData?.bjInfo.globalYN === "Y"
    })}>{tab_0.label}</PageTab>);
    $[5] = bjInfoData?.bjInfo;
    $[6] = channelId;
    $[7] = isMyChannel;
    $[8] = router;
    $[9] = t2;
    $[10] = userInfo?.authYN;
    $[11] = userInfo?.isBJ;
    $[12] = wasLive;
    $[13] = T0;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    T0 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
  }
  let t7;
  if ($[18] !== T0 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5) {
    t7 = <T0 className={t3} contentClassName={t4}>{t5}</T0>;
    $[18] = T0;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t6 || $[24] !== t7) {
    t8 = <div data-testid={t6}>{t7}</div>;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
}
function _temp(tab) {
  return tab.condition;
}
export default ChannelTabsContainer;